import './TestItem.css';
import React from 'react';

function TestItemSkeleton() {
    return (
        <div className="test-item-skeleton">
            <div className="test-item-skeleton-content">
                <div className="test-item-skeleton-title-row">
                    <div className="test-item-skeleton-title" />
                    <div className="test-item-skeleton-badge" />
                </div>
                <div className="test-item-skeleton-desc" />
                <div className="test-item-skeleton-meta" />
            </div>
        </div>
    );
}

export default TestItemSkeleton;
